"use strict";

require("../../style/index.less");

require("./index.less");

require("../../tabs/style");

require("../../row/style");

require("../../col/style");


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/card/style/index.js
// module id = 98
// module chunks = 1